<template>
  <app-page-subsection
    v-if="course.description"
    id="overview"
    :title="{ tag: 'h3', text: $t('course.page.description_title') }"
  >
    <app-text-clamped :max-lines="6" @unclamp="onUnclamp">
      <app-text-markdown
        class="prose max-w-[900px] text-subtle"
        lazy
        :value="course.description"
      />
    </app-text-clamped>
  </app-page-subsection>
</template>

<script lang="ts" setup>
defineProps<{
  course: Pick<DatabaseTable<"courses">, "description">;
}>();

const { $analytics } = useNuxtApp();

const onUnclamp = () => {
  $analytics.track("course_description_unfolded");
};
</script>
